import { isLocalCalendarEntry } from 'owa-calendar-cache';
import { isMeetingOnCalendarSharedWithMe } from 'owa-calendar-event-capabilities';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export const isSharedItem = (event: CalendarEvent) => (): boolean => {
    return isMeetingOnCalendarSharedWithMe(event);
};

export const isRemoteItem = (event: CalendarEvent) => (): boolean => {
    let isRemote = !isLocalCalendarEntry(event.ParentFolderId.Id);
    return isRemote;
};
